const hotpointSections = document.querySelectorAll('.hotpoints');

if (hotpointSections) {
    hotpointSections.forEach(section => {
        const singleDots = section.querySelectorAll('.hotpoints__single-dot');
        const activeClass = 'active';
        const infoWrapper = section.querySelector('.hotpoints__single-info');

        const handleImageClick = e => {
            if (singleDots) {
                singleDots.forEach(dot => dot.classList.remove(activeClass));
                infoWrapper.classList.remove(activeClass);
            }
        };

        if (singleDots) {
            let headingElement;
            let descriptionElement;
            if (infoWrapper) {
                headingElement = infoWrapper.querySelector(
                    '.hotpoints__single-heading'
                );
                descriptionElement = infoWrapper.querySelector(
                    '.hotpoints__single-description'
                );
            }
            const handleInfoData = data => {
                const { heading, description, top, left } = JSON.parse(data);
                if (heading || description) {
                    if (headingElement) {
                        headingElement.textContent = heading;
                    }
                    if (description) {
                        descriptionElement.innerHTML = description;
                    }
                    if (window.innerWidth < 576) {
                        infoWrapper.style.top = `calc(${top}% + 44px)`;
                        infoWrapper.style.left = `54%`;
                    } else {
                        infoWrapper.style.top = `calc(${top}% - 16px)`;
                        infoWrapper.style.left = `calc(${left}% + 54px)`;
                    }
                    infoWrapper.classList.add(activeClass);
                } else {
                    return;
                }
            };
            const handleDotClick = (e, data) => {
                const { target } = e;
                if (!target.classList.contains(activeClass)) {
                    if (headingElement) {
                        headingElement.textContent = '';
                    }
                    if (descriptionElement) {
                        descriptionElement.innerHTML = '';
                    }
                    infoWrapper.classList.remove(activeClass);
                    singleDots.forEach(singleDot =>
                        singleDot.classList.remove(activeClass)
                    );
                    setTimeout(() => {
                        target.classList.add(activeClass);
                        handleInfoData(data);
                    }, 100);
                } else {
                    target.classList.remove(activeClass);
                    infoWrapper.classList.remove(activeClass);
                }
            };
            singleDots.forEach(dot => {
                const data = dot.parentElement.getAttribute('data-info');
                dot.addEventListener('click', e => handleDotClick(e, data));
            });
            window.addEventListener('resize', () => {
                const activeDots = document.querySelectorAll(
                    '.hotpoints__single-dot.active'
                );
                if (activeDots && activeDots.length > 0) {
                    singleDots.forEach(singleDot =>
                        singleDot.classList.remove(activeClass)
                    );
                    infoWrapper.classList.remove(activeClass);
                }
            });
        }

        const sectionImage = section.querySelector('.hotpoints__image');
        const sectionMobileImage = section.querySelector(
            '.hotpoints__image-mobile'
        );
        if (sectionImage) {
            sectionImage.addEventListener('click', handleImageClick);
        }
        if (sectionMobileImage) {
            sectionMobileImage.addEventListener('click', handleImageClick);
        }
    });
}
